var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-alarm-actions-chips',{attrs:{"items":_vm.entity.tag_colors,"inline-count":_vm.inlineCount,"item-class":"c-entity-tags-chips__chip","item-text":"value","item-value":"value","row":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }